import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { LoginRegisterService } from '../login-register/login-register.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})

export class FooterComponent implements OnInit, OnDestroy {

  loginSuccess: boolean;
  currentYear = 2024;
  private subs = new Subscription();
  constructor(private router: Router, private loginRegisterService: LoginRegisterService) { }

  ngOnInit(): void {
    this.currentYear = new Date().getFullYear();
    this.subs.add(this.loginRegisterService.currentUser.subscribe((res) => {
      if (res) {
        this.loginSuccess = true;
      } else {
        this.loginSuccess = false;
      }
    }));
  }

  footerMenuClick(routeName, signupView = false): void {
    this.router.navigate([routeName], { queryParams: { signupView: signupView } });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

}
